<template>
  <div id="submission-list" class="list">
    <div class="submission-list-header list-header">
      <ul>
        <li>{{$_('submission_number')}}</li>
        <li>{{$_('date')}}</li>
        <li>{{$_('type')}}</li>
        <li>{{$_('order_number')}}</li>
        <li>{{$_('customer_reference')}}</li>
        <li>{{$_('article')}}</li>
        <li>{{$_('color')}}</li>
        <li>{{$_('status')}}</li>
        <li>{{$_('submission_deadline')}}</li>
        <li>{{$_('acceptance_date')}}</li>
      </ul>
    </div>
    <div class="submission-list-body list-body" v-if="pagination_info.nNbRecordData !== 0">
      <div v-for="(item, index) in items" :key="index">
        <SubmissionLine :dataline="item" :index="index" />
      </div>
    </div>
    <div v-else>
      <div class="no-result" >
        <span>{{$_('no_submission')}}</span>
      </div>
    </div>
    <div class="pagination-container">
      <Pagination 
        :nNumeroPage="pagination_info.nNumeroPage" 
        :nNombreElementParPage="pagination_info.nNombreElementParPage" 
        :nNbElementTotal="pagination_info.nNbRecordData" 
        :sTypeElement="$_('submissions')" 
        :fn="getSubmission"
        :key="render"
      />
    </div>
  </div>
</template>

<script>
import submissionService from '@/modules/soumission/services/submissionService.js';
import Pagination from '@/common/components/widget/Pagination/Pagination'
import SubmissionLine from '@/modules/soumission/components/SubmissionLine';

export default {
    data() {
      return {
        items: Array(),
        status_data: [
          {FSTATUS: 'O', TLIB_FSTATUS: this.$_('yes').toUpperCase()},
          {FSTATUS: 'N', TLIB_FSTATUS: this.$_('no').toUpperCase()},
        ],
        pagination_info: {
          nNumeroPage: 1,
          nNombreElementParPage: 20,
          nNbRecordData: 0,
        },
        render: 0
      };
    },
    created() {
      if(this.$route.params.submission_id === undefined) {
        this.getSubmission();
      }
    },
    components: {
      Pagination,
      SubmissionLine
    },
    computed: {
      getResearch() {
        return this.$store.getters['soumission/get_research']
      },
      getFnsoum() {
        return this.$store.getters['soumission/get_fnsoum'];
      }
    },
    watch: { 
      getResearch(value) {
        if(value === true) {
          this.getSubmission()
        }
      },
      getFnsoum(val) {
        if(this.$route.params.submission_id !== undefined) {
          this.getSubmission();
        }
      }
    },
    methods: {
      getSubmission(nNumeroPage, nNombreElementParPage) {

        let poffset = 0;

        if (nNumeroPage > 0) {
          poffset = nNumeroPage * nNombreElementParPage;
        }

        if (this.$store.getters["soumission/get_reset_submission_list"]) {
          this.items = Array();
        }

        return submissionService.getSoumission({
          fnsoum: this.$store.getters['soumission/get_fnsoum'] !== '' ? this.$store.getters['soumission/get_fnsoum'] : null,
          frefc: this.$store.getters['soumission/get_frefc'] !== '' ? this.$store.getters['soumission/get_frefc'] : null,
          fcetat: this.$store.getters['soumission/get_fcetat'] !== '' ?  this.$store.getters['soumission/get_fcetat'] : null, 
          fcetatd: this.$store.getters['soumission/get_fcetatd'] !== '' ? this.$store.getters['soumission/get_fcetatd'] : null, 
          fcetate: this.$store.getters['soumission/get_fcetate'] !== '' ? this.$store.getters['soumission/get_fcetate'] : null, 
          fcetata: this.$store.getters['soumission/get_fcetata'] !== '' ? this.$store.getters['soumission/get_fcetata'] : null, 
          fcetatr: this.$store.getters['soumission/get_fcetatr'] !== '' ? this.$store.getters['soumission/get_fcetatr'] : null, 
          fcetatt: this.$store.getters['soumission/get_fcetatt'] !== '' ? this.$store.getters['soumission/get_fcetatt'] : null, 
          fcetat_sup: this.$store.getters['soumission/get_fcetat_sup'] !== '' ? this.$store.getters['soumission/get_fcetat_sup'] : null, 
          fcol: this.$store.getters['soumission/get_fcol'] ? this.$store.getters['soumission/get_fcol'] : null,
          fstatus: this.$store.getters['soumission/get_fstatus'] ? this.$store.getters['soumission/get_fstatus'] : null,
          fdate_soum: this.$store.getters['soumission/get_fdate_soum'] ? this.$store.getters['soumission/get_fdate_soum'] : null ,
          poffset,
          plimit: 20,
        })
        .then(res => {

          this.pagination_info.nNbRecordData = res.data.NB_RECORD;

          if(res.data.DS_O !== undefined) {
            setTimeout(() => {
              res.data.DS_O.OUT.map(obj => {
                this.items.push(obj);
              });
            }, 300);
          }

          this.$store.dispatch('soumission/SELECT', {key: 'reset_submission_list', value: false});
          this.$store.dispatch('soumission/SELECT', {key: 'launch_research', value: false});

          return this.pagination_info;
        })
        .catch(err => {
          console.error(err)
        });
      }
    }
}
</script>

<style scoped>
.submission-list-header ul {
  display: flex;
  align-items: center;
}
.submission-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 10);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.submission-list-header {
  padding: 15px 0px;
}
.no-result {
  text-align: center;
  padding: 20px;
  border: solid 1px #e9e9e9;
  margin-bottom: 20px;
}
.no-result span {
  color: #8B8B8B;
}
.submission-list-body {
  margin-bottom: 20px;
}
</style>